<fieldset>
  <div class="form-group" [class.row]="!_detailViewComponent.smallScreen">
    <label
      class="col-form-label"
      [class.col-4]="!_detailViewComponent.smallScreen"
      [class.text-right]="!_detailViewComponent.smallScreen"
      [class.required]="prop.field_required"
    >
      {{ prop.field_label | translate }}
    </label>
    <div [class.col-8]="!_detailViewComponent.smallScreen">
      <div class="form-check" *ngFor="let opt of prop.opts">
        <div class="pretty p-default p-round p-smooth">
          <input
            class="form-check-input"
            type="radio"
            [name]="prop.field_name"
            [id]="prop.field_id"
            [value]="opt.value"
            [formControl]="graphicFormGroup.controls[prop.field_name]"
          />
          <div class="state">
            <label>{{ opt.label }}</label>
          </div>
          <error-tooltip [errorMessages]="errorMessages"></error-tooltip>
        </div>
      </div>
    </div>
  </div>
</fieldset>
